import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import NavbarMenu from "../heroSection/NavbarMenu";
import { FaTruck, FaUser, FaArrowRight } from "react-icons/fa";
import "./RegisterSelectPage.css";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";

export default function RegisterSelectPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="TransCirox – Registrieren | Jetzt kostenlos anmelden"
        description="Erstellen Sie jetzt Ihr kostenloses TransCirox-Konto – als Privatkunde oder Transportpartner. Einfache und schnelle Registrierung."
        keywords="TransCirox Registrieren, Konto erstellen, Anmeldung, kostenlos registrieren"
      />
      <NavbarMenu />

      <Container
        fluid
        className="py-5 d-flex justify-content-center align-items-center dark-register-page"
        style={{ minHeight: "70vh" }}
      >
        <Row className="w-100 justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6} xl={5}>
            <Card className="text-center dark-register-card border-0">
              <h2 className="mb-3">
                {t("registerSelect.title", "Konto erstellen")}
              </h2>
              <p className="mb-4 text-muted">
                {t(
                  "registerSelect.description",
                  "Wählen Sie den Kontotyp, der am besten zu Ihnen passt"
                )}
              </p>

              <div className="d-grid gap-4">
                {/* ✅ زر السائق */}
                <Button
                  className="driver-btn text-white border-0"
                  size="lg"
                  onClick={() => navigate("/register/driver")}
                >
                  <FaTruck />
                  <span className="flex-grow-1 text-start">
                    {t("registerSelect.driverButton", "Als Fahrer registrieren")}
                  </span>
                  <FaArrowRight className="ms-2" style={{ fontSize: 16 }} />
                </Button>

                {/* ✅ زر العميل */}
                <Button
                  className="client-btn border-2"
                  size="lg"
                  onClick={() => navigate("/register/client")}
                >
                  <FaUser />
                  <span className="flex-grow-1 text-start">
                    {t("registerSelect.clientButton", "Als Kunde registrieren")}
                  </span>
                  <FaArrowRight className="ms-2" style={{ fontSize: 16 }} />
                </Button>
              </div>

              {/* ✅ رابط تسجيل الدخول */}
              <div className="mt-4 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
                <p className="text-muted mb-0" style={{ fontSize: 14 }}>
                  {t("registerSelect.haveAccount", "Sie haben bereits ein Konto?")}{" "}
                  <a
                    href="/login"
                    className="fw-bold text-decoration-none"
                    style={{ color: "var(--orange-primary, #ff7b00)" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/login");
                    }}
                  >
                    {t("registerSelect.login", "Jetzt anmelden")}
                  </a>
                </p>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}